export default {
    aside_update_now: "Update Now",
    aside_smart_card: "Smart Card",
    aside_forms: "Forms",
    aside_list: "List",
    aside_alert_response: "Alert & Response",
    aside_notifications: "Notifications",
    aside_btn_call_link: "Btn Call Link",
    aside_bstore: "bStore",
    aside_products: "Products",
    aside_orders: "Orders",
    aside_todays_deals: "Today's Deals",
    aside_plugins: "Plugins",
    aside_projects: "Projects",
    aside_bmenu: "bMenu",
    aside_setup: "Setup",
}
